// Module
var code = "<div id=\"V-E7E9BA0B-F40A-4C1A-8FA6-EA2BFD6BE821\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding fontStyleSelector}\"></div> </div> ";
// Exports
export default code;